export const lastBluetoothError: { error: any, msg: string } = {
  error: undefined,
  msg: "",
};

export function setLastBluetoothError(error: any) {
  lastBluetoothError.error = error;
}
